import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GetPipelinesForPipelineItemsQueryVariables = Types.Exact<{
   params: Types.GetPipelinesForPipelineItemsParams
}>

export type GetPipelinesForPipelineItemsQuery = {
   __typename?: 'Query'
   getPipelinesForPipelineItems:
      | {
           __typename?: 'PipelineItemsAccessDenied'
           message?: string | null
           pipelineItemIds: Array<string>
        }
      | {
           __typename?: 'PipelineItemsAreDeleted'
           message?: string | null
           pipelineItemIds: Array<string>
        }
      | {
           __typename?: 'PipelineItemsNotFound'
           message?: string | null
           pipelineItemIds: Array<string>
        }
      | {
           __typename?: 'PipelinesForPipelineItemsResult'
           pipelineItemWisePipelines: Array<{
              __typename?: 'PipelineItemPipelines'
              pipelineItemId: string
              pipelines: Array<{
                 __typename?: 'PipelineItemAssociatedPipeline'
                 hasPermission: boolean
                 pipeline: { __typename?: 'BasePipeline'; pipelineId: string }
              }>
           }>
        }
}

export const GetPipelinesForPipelineItemsDocument = gql`
   query GetPipelinesForPipelineItems(
      $params: GetPipelinesForPipelineItemsParams!
   ) {
      getPipelinesForPipelineItems(params: $params) {
         ... on PipelinesForPipelineItemsResult {
            pipelineItemWisePipelines {
               pipelineItemId
               pipelines {
                  hasPermission
                  pipeline {
                     pipelineId
                  }
               }
            }
         }
         ... on PipelineItemsNotFound {
            message
            pipelineItemIds
         }
         ... on PipelineItemsAccessDenied {
            message
            pipelineItemIds
         }
         ... on PipelineItemsAreDeleted {
            message
            pipelineItemIds
         }
      }
   }
`
export type GetPipelinesForPipelineItemsQueryResult = Apollo.QueryResult<
   GetPipelinesForPipelineItemsQuery,
   GetPipelinesForPipelineItemsQueryVariables
>
